import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { OVERVIEW } from 'app/@common/constants'


export default function SelectMonth({...props}) {

    const myProps = {
        urlAjax: OVERVIEW.DATE_RANGE,
        icon: { icon: 'calendar' },
        firstSelect: true,
        ...props
    }
    
    return <SelectAjaxSeeker {...myProps} />
}